import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../store/auth";
import { api } from "../helpers/api";
import useCategories from "../store/categories";

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("worldPayToken");
  const { isGuest } = useAuth();
  const { fetchCategories } = useCategories();

  const [isIdle, setIsIdle] = useState(false);
  api.interceptors.response.use(
    (response) => response, 
    (error) => {
      console.log(error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("worldPayToken");
        navigate("/login");
      }
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    let timer;

    const resetTimer = () => {
      setIsIdle(false);
      clearTimeout(timer);
      timer = setTimeout(() => {
        setIsIdle(true);
        localStorage.removeItem("worldPayToken");
        navigate("/login");
      }, 3600000 * 3);
    };

    // Faoliyatni kuzatish
    const activityEvents = ["mousemove", "keydown"];
    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });
    resetTimer();
    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (!token && !isGuest) {
      navigate("/login");
    }
  }, [token, isGuest]);
  useEffect(() => {
    fetchCategories();
  }, []);

  return token && children;
};

export default PrivateRoute;
